function getCurrentTheme() {
	return localStorage.getItem('theme');
}

export { getCurrentTheme };
